module.exports = __webpack_public_path__ + "static/media/blog_img6.422bd766.png";